export const INDETERMINATE = "indeterminate";
export const DETERMINATE = "determinate";
